import type { DependencyList } from 'react';
import { useEffect, useRef } from 'react';

type Callback<A, R> = (arg: A) => R;

function useClosure<A, R>(
  callback: Callback<A, R>,
  dependencies: DependencyList = [],
) {
  const ref = useRef<Callback<A, R>>(callback);

  useEffect(() => {
    ref.current = callback;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, react-hooks/exhaustive-deps
  }, [callback, ...dependencies]);

  return (arg: A) => ref.current(arg);
}

export { useClosure };
